<template>
  <hs-alert
    :show.sync="showSortDialog"
    :cancelBtn="$t('Cancel')"
    :confirmBtn="$t('ReQuery')"
    :title="''"
    @confirm="_confirm"
  >
    <div slot="content" class="c-small-fourteen-alert">
      <p v-if="details.PassengerType === 2">{{$t('ChildrenReQuery')}}</p>
      <p v-if="details.PassengerType === 3">{{$t('BabyReQuery')}}</p>
      <!--儿童 婴儿 start-->
      <children-infants class="children-box" ref="ChildrenInfants" :hasChildren="hasChildren" :hasBaby="hasBaby" @selectBaby="_selectBaby" @selectChildren="_selectChildren" />
      <!--儿童 婴儿 end-->
    </div>
  </hs-alert>
</template>
<script type="text/ecmascript-6">
export default {
  name: 'c-small-fourteen-alert',
  props: {
    title: {
      type: String,
      default: ''
    },
    details: {
      type: Object,
      default: () => {
        return {}
      }
    },
    confirmFn: {
      type: Function,
      default: () => {
        return () => {}
      }
    }
  },
  computed: {},
  watch: {
    showSortDialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.hasChildren = this.details.IsCarryChild
          this.hasBaby = this.details.IsCarryInfant
        })
      }
    }
  },
  data() {
    return {
      showSortDialog: false,
      hasChildren: false,
      hasBaby: false,
      currentData: []
    }
  },
  methods: {
    show() {
      this.showSortDialog = true
    },
    close() {
      this.showSortDialog = false
    },
    getIsOpen() {
      if (this.showSortDialog) {
        this.close()
        return true
      }
      return false
    },
    // 选择儿童
    _selectChildren(val) {
      this.hasChildren = val
    },

    // 选择儿童
    _selectBaby(val) {
      this.hasBaby = val
    },

    // 确定
    _confirm() {
      this.confirmFn(this.hasChildren, this.hasBaby)
    }
  },
  components: {
    ChildrenInfants: () => import('components/c-passenger/children-infants'),
    HsAlert: () => import('base/hs-alert/hs-alert')
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.c-small-fourteen-alert
  padding 0 30px
  font-size 15px
  color $color_font_black
  >p
    text-align center
    line-height 1.5em
    margin-bottom 10px
    color $color_font_black_2
  .Children-infants
    padding 10px 10px
    >>> .content
      @extend .flex-between
      width 100%
</style>
